import * as React from 'react'
// import { Main } from '../../../Logic/Main'
import * as Body from './Body'
// import * as Lounge from './Lounge'
import Socket from '../../../Socket/socket-init'
import * as Assets from '../../../assets/Assets'
import * as Utils from '../../../Logic/Utils'
// import * as Utils from '../../../Logic/Utils'
// import * as Assets from '../../../assets/Assets'
import { Link } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import Loader from './Loader'
import {Helmet} from 'react-helmet'

interface IState {
    userDropdown: boolean
    leaguesTab: number
    leagueName: string
    leagueCode: string
    mobileMenu: boolean
    emails: string
}

class Leagues extends React.Component<{}, IState> {

    public cookies

    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            leaguesTab: 1,
            leagueName: '',
            leagueCode: '',
            mobileMenu: false,
            emails: ''
        }

        Socket.Send('user-leagues', { playerId: +this.cookies.get('playerId'), tab: +this.cookies.get('competitionTab') })

        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleInput(value: string, state: string) {
        this.state[state] = value
        this.setState(this.state)
    }

    handleSubmit(event) {
        event.preventDefault()
        if (this.state.emails === '') {
          alert ('Please write at least one email address.')
        } else {
          Socket.Send('send-league-code', {email: this.state.emails})
        }
    }

    render() {
        const createLeagueReturn = Socket.Get<any>('create-league')
        const joinLeagueReturn = Socket.Get<any>('join-league')
        const userLeagues = Socket.Get<any>('user-leagues')
        if (userLeagues.loading !== 'loaded') {
            return <Loader/>
        } else {
            return (
                <section className="wrapper">
                    <Helmet>
                        <meta charSet="utf-8"/>
                        <title>The Accumulator Club – Premier League predictions - Leagues</title>
                        <meta 
                            name="description" 
                            content="The Accumulator Club is the ultimate punting championship – Compete in private
                            leagues against friends and colleagues in this free to play football game. Our unique social betting
                            format awards points for correct predictions based on real sportsbook odds, who is the best punter?"
                        />
                    </Helmet>
                    <div className="header" role="banner">
                        <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                            <div className="container">
                                <div className="navbar-header">
                                    <button
                                        onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                        type="button"
                                        className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'}
                                        data-toggle="collapse"
                                        data-target="#navbar-collapse-mid"
                                        aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    >
                                        <span className="sr-only">Toggle navigation</span>
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    </button>
                                    <Link className="navbar-brand" to="/">
                                        <img src={Assets.logoMain} alt="" className="logo" />
                                    </Link>
                                    <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                                </div>
                                <nav
                                    className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'}
                                    id="navbar-collapse-left"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                                >
                                    {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                                </nav>
                                <nav className="collapse navbar-collapse" id="user-profile">
                                    <ul className="nav navbar-nav navbar-right">
                                        <li className="user-nav-option">
                                            <div className="user">
                                                <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                    <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                        <a href="javascript:void(0);"><i className="icon-plus-circular" /></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        {(this.cookies.get('username')) ? 
                                        <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                            <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                                <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                            </a>
                                            <ul className="dropdown-menu">
                                                    <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                    <li onClick={() => Utils.logout()}>
                                                    <Link to="/login">
                                                        <i className="icon-logout"/>
                                                        LOGOUT
                                                    </Link>
                                                    </li>
                                            </ul>
                                        </li>
                                        :
                                        null}
                                    </ul>
                                </nav>
                            </div>
                        </header>
                    </div>
                    <main className="main">
                        <div className="container">
                            <div className="section-left">
                                <div className="left-cont-main ">
                                    <div className="section-content pad_zero">
                                        <ul className="nav nav-tabs nav-justified nav-lg leagues-tabs" role="tablist">
                                            <li role="presentation" className={(this.state.leaguesTab === 1) ? 'active league-font' : 'league-font'}><a href="javascript:void(0);" onClick={() => this.setState({ leaguesTab: 1 })} aria-expanded={(this.state.leaguesTab === 1) ? 'true' : 'false'} aria-controls="create" role="tab" data-toggle="tab">CREATE A  LEAGUE</a></li>
                                            <li role="presentation" className={(this.state.leaguesTab === 2) ? 'active league-font' : 'league-font'}><a href="javascript:void(0);" onClick={() => this.setState({ leaguesTab: 2 })} aria-expanded={(this.state.leaguesTab === 2) ? 'true' : 'false'} aria-controls="join" role="tab" data-toggle="tab">JOIN  A  LEAGUE</a></li>
                                        </ul>
                                        <div className="tab-content custom">
                                            {(this.state.leaguesTab === 1) ?
                                                <div role="tabpanel" className="tab-pane active" id="create-a-league">
                                                    <span className="bold">Accumulator Club</span> immerses you in the middle of the action! Push the excitement and competition to the max, test that Football brain and find your punting strategy to get ahead. You will automatically compete for global supremacy and top prizes, but you can also challenge friends and colleagues and see who comes out on top in your own private league.
                                                <div className="clearfix mT20" />
                                                    <span>It’s simple, just enter a suitable name for your league in the box below, click to CREATE and job done – You will see your unique league code on-screen and a copy will be sent to your email. Share it with friends and foes and enjoy this unique gaming experience – Good luck!</span>
                                                    <div className="clearfix mT20" />
                                                    <div className="form-400">
                                                        <div className="form-group">
                                                            <label>League Name</label>
                                                            <input type="text" id="L_name" className="form-control" placeholder="" value={this.state.leagueName} onChange={(event) => this.handleInput(event.target.value, 'leagueName')} />
                                                        </div>
                                                        <div className="clearfix mT20" />
                                                        <div className="form-group">
                                                            <button className="btn btn-lg btn-block btn-primary no-shadow" onClick={() => this.createLeague()}>CREATE</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div role="tabpanel" className="tab-pane active" id="join-a-league">
                                                    <span>Has someone sent you a code to join a private league? ...What a legend! In addition to battling with friends and foes for top spot in your private league, you will automatically compete for global supremacy and top prizes as well.</span>
                                                    <div className="clearfix mT20" />
                                                    <span>Please enter the code in the box below and click CONFIRM THE CODE. As long as the code is valid you will see a message to say you’re in. Shortly afterwards you will be able to access the league table from this page (LEAGUES), or the LOUNGE page. Enjoy this unique gaming experience and good luck!</span>
                                                    <div className="clearfix mT20" />
                                                    <div className="form-400">
                                                        <div className={(joinLeagueReturn.joinLeague && joinLeagueReturn.joinLeague.error) ? 'form-group has-error' : 'form-group'}>
                                                            <label>Code</label>
                                                            <input type="text" id="code" className="form-control" placeholder="" value={this.state.leagueCode} onChange={(event) => this.handleInput(event.target.value, 'leagueCode')} />
                                                            <span className="error-block"><span>Incorrect Code</span></span>
                                                            <span className="error-block-lg">
                                                                Ooops! There is no league associated with this code. Please check and try again.
                                                        </span>
                                                        </div>
                                                        <div className="clearfix mT20" />
                                                        <div className="form-group">
                                                            <button className="btn btn-lg btn-block btn-primary no-shadow" onClick={() => this.joinLeague()}>CONFIRM THE CODE</button>
                                                        </div>
                                                    </div>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="section-right">
                                <div className="league-rank">
                                    <div className="section-heading"> RANKINGS </div>
                                    <div className="section-content">
                                        <div className="row">
                                            <ul className="list-unstyled">
                                                <li>
                                                <a href="javascript:void(0);" /*onClick={() => {Lounge.getLeaderboards(), Logic.Type.New(Main.Instance.Fantasy, {overallRanking: true})}} title="">
                                                    <div className="league">
                                                    <span className="bold">Overall ranking</span>
                                                    </div>
                                                </a>
                                                </li>&& createLeagueReturn.createLeague.message
                                                {/*Lounge.setLeagues(userLeagues.userLeagues)
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>*/}
                            <div className="section-right">
                                <div className="league-rank">
                                    <div className="section-heading">SOCIAL CHANNELS</div>
                                    <div className="section-content">
                                        <span className="social-span" style={{ marginTop: '10px' }}>
                                            <iframe 
                                                src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Faccumulatorclub%2F&width=88&layout=button_count&action=like&size=large&show_faces=false&share=false&height=21&appId" 
                                                width="150" 
                                                height="30" 
                                                style={{ border:'none', overflow:'hidden'}}
                                                scrolling="no"
                                            />
                                        </span>
                                        <span className="social-span" style={{ background: '#1b95e0', marginBottom: '10px' }}>
                                            <a href="https://twitter.com/TheAccaClub?ref_src=twsrc%5Etfw" data-show-count="false">Follow @TheAccaClub</a>
                                            <script async={true} src="https://platform.twitter.com/widgets.js"/>
                                        </span>
                                    </div>
                                </div>
                                {(this.cookies.get('playerId')) ?
                                    <div className="league-rank">
                                        <div className="section-heading">MY LEAGUES</div>
                                        <div className="section-content">
                                            <div className="row">
                                                <ul className="list-unstyled">
                                                    <li style={{ background: 'rgb(231, 231, 231)' }}>
                                                        <div className="league">
                                                            <span className="bold">Private leagues</span>
                                                            <span>{''}</span>
                                                        </div>
                                                    </li>
                                                    {this.setLeagues()}
                                                </ul>
                                            </div>
                                            <div className="row" style={{ background: 'rgb(231, 231, 231)' }}>
                                                <ul className="list-unstyled">
                                                    <li>
                                                        <Link 
                                                            onClick={() => Socket.Send('leaderboards', {playerId: +this.cookies.get('playerId'), tab: +this.cookies.get('competitionTab')})}
                                                            to={{ pathname:'/leaderboards', state: { overallRanking: true } }}
                                                        >
                                                            <div className="league">
                                                                <span className="bold">Overall ranking</span>
                                                                <span>{''}</span>
                                                            </div>
                                                            <div className="league-ranking">
                                                                <span className="badge badge-warning bagde-rank">{userLeagues.userLeagues[0].playerPosition.toString()}</span>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                : null}
                            </div>
                        </div>
                        {(createLeagueReturn.createLeague && createLeagueReturn.createLeague.leagueCode) ?
                            this.showPopup(1)
                            : null}
                        {(joinLeagueReturn.joinLeague && joinLeagueReturn.joinLeague.leagueName) ?
                            this.showPopup(2)
                            : null}
                    </main>
                </section>
            )
        }
    }

    createLeague() {
        Socket.Send('create-league', { adminId: +this.cookies.get('playerId'), leagueName: this.state.leagueName, tab: +this.cookies.get('competitionTab') })
        this.setState({
            leagueName: ''
        })
    }

    joinLeague() {
        Socket.Send('join-league', { playerId: +this.cookies.get('playerId'), leagueKey: this.state.leagueCode })
        this.setState({
            leagueCode: ''
        })
    }

    setLeagues(): JSX.Element[] {
        const leaguesReturn: JSX.Element[] = []
        const userLeagues = Socket.Get<any>('user-leagues').userLeagues
        if (userLeagues.length < 2) {
          leaguesReturn.push(
            <li key={leaguesReturn.length}>
              <Link 
                to={(!this.cookies.get('playerId')) ? '/login' : '/leagues'}   
              >
                <div className="league">
                  <span className="bold">No private league created yet!</span>
                </div>
              </Link>
            </li>
          )
        }
        for (let i = 1; i < userLeagues.length; i++) {
          leaguesReturn.push(
            <li key={leaguesReturn.length}>
              <Link 
                to="/leaderboards"
                onClick={() => {Socket.Send('leaderboards', {playerId: +this.cookies.get('playerId'), tab: +this.cookies.get('competitionTab'), league: userLeagues[i].leagueId})
                                localStorage.setItem('leaderboardLeagueName', userLeagues[i].leagueName)
                                localStorage.setItem('leagueId', userLeagues[i].leagueId)
                                localStorage.setItem('leagueCode', userLeagues[i].leagueCode)
                                localStorage.setItem('overallRanking', 'false')}}    
              >
                <div className="league">
                  <span className="bold">{userLeagues[i].leagueName}</span>
                  <span>By {userLeagues[i].leagueAdmin}</span>
                </div>
                <div className="league-ranking">
                  <span className="badge badge-warning bagde-rank">{userLeagues[i].playerPosition.toString()}</span>
                </div>
              </Link>
            </li>
          )
        }
      
        return leaguesReturn
    }

    showPopup(type: number): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 150
        const top = screenPosition.toString() + 'px'
        const createLeague = Socket.Get<any>('create-league').createLeague
        const joinLeague = Socket.Get<any>('join-league').joinLeague
        return (
            <div className="popup">
                <div className="popup-inner popup-forgot" style={{ top }}>
                    <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                        <img 
                            src="cancel-black.png"
                            onClick={() => { Socket.Send('user-leagues', { playerId: +this.cookies.get('playerId'), tab: +this.cookies.get('competitionTab') })
                                            Socket.Set('create-league', {}) 
                                            Socket.Set('join-league', {})
                                            if (type === 1) Socket.Send('send-league-code', {username: this.cookies.get('username'), leagueName: createLeague.leagueName, leagueCode: createLeague.leagueCode}) }} 
                            style={{ cursor: 'pointer' }} 
                        />
                    </div>
                    <p className="congratulations-first">Congratulations!</p>
                    {(type === 1) ?
                        <p className="congratulations-second">
                            Your league <span style={{ color: 'rgb(41, 160, 0)' }}>{createLeague.leagueName}</span> has been created successfully.
                    </p>
                        :
                        <p className="congratulations-second">
                            You have succesfully joined league <span style={{ color: 'rgb(41, 160, 0)' }}>{joinLeague.leagueName}</span>.
                    </p>
                    }
                    {(type === 1) ?
                        <div>
                            <p className="congratulations-third">Use the Code given below to share directly with your friends.</p>
                            <div className="congratulations-code">
                                <span>Code</span>
                                <span>{createLeague.leagueCode}</span>
                            </div>
                        </div>
                        : null}
                </div>
            </div>
        )
    }
}

export default withCookies(Leagues)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Leagues.tsx